<template>
  <v-container fluid>
    <v-layout>
      <v-flex>
        <h3 class="headline">Ads</h3>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn outline color="grey">
          <i class="fas fa-file-export mr-1"></i>
          {{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <date-filter v-model="selectedDate" @onSelected="getAds"></date-filter>

    <v-data-table
      :items="ads"
      class="elevation-1"
      hide-actions
      :headers="headers"
      :expand="false"
      item-key="refcode"
    >
      <template v-slot:items="props">
        <tr @click="props.expanded = !props.expanded">
          <td class="primary--text">
            {{ props.item.refcode != 'nottag' ? props.item.refcode : 'Not ads' }}
          </td>
          <td class="text-xs-right">{{ props.item.sumorders }}</td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card flat color="grey lighten-3" style="width: 100%">
          <v-card-text>
            <aston-ads-detail
              :value="props.item.refcode"
              :datefrom="selectedDate.start"
              :dateto="selectedDate.end"
            ></aston-ads-detail>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'
import AstonAdsDetail from './AstonAdsDetail'
export default {
  data: function() {
    return {
      headers: [
        {
          text: 'Ads',
          align: 'left',
          value: 'refcode'
        },
        { text: 'Count', value: 'sumorders', align: 'right' }
      ],
      ads: [],
      selectedDate: {
        start: moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        end: moment()
          .endOf('month')
          .format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    DateFilter,
    AstonAdsDetail
  },
  mounted: function() {
    this.getAds()
  },
  methods: {
    getAds: function() {
      var vm = this
      vm.getAstonTagOrderFromAds().then(function(ads) {
        vm.ads = ads
      })
    },
    getAstonTagOrderFromAds: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(vm.selectedDate.start).format('YYYY/MM/DD'),
          dateto: moment(vm.selectedDate.end).format('YYYY/MM/DD')
        }
        api.getAstonTagOrderFromAds(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            resolve(response.data)
          }
          resolve([])
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AstonAds.vue